import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Badge } from "@shared/ui/badge";
import React from "react";
import { useParams } from "react-router-dom";

const ExecutionDetails = ({ data }: { data: any }) => {

  // This data would come from your API
  const executionData = {
    workflowName: data?.result?.workflowName,
    executionDate: data?.result?.executionDate,
    executionTime: data?.result?.executionTime,
    executionStatus: data?.result?.executionStatus, // or 'Failed', 'Pending', 'In Progress'
    channel: data?.result?.channel,
    audienceType: data?.result?.audienceType,
    actionType: data?.result?.actionType,
  };

  const executionDetails = [
    {
      label: "Workflow Name",
      value: executionData?.workflowName,
    },
    {
      label: "Execution Date",
      value: executionData?.executionDate,
    },
    {
      label: "Execution Time",
      value: executionData?.executionTime,
    },
    {
      label: "Execution Status",
      value: executionData?.executionStatus,
    },
    {
      label: "Channel",
      value: executionData?.channel,
    },
    {
      label: "Audience Type",
      value: executionData?.audienceType,
    },
    {
      label: "Action Type",
      value: executionData?.actionType,
    },
  ];

  // Helper function to get status badge variant
  const getStatusVariant = (status: string) => {
    switch (status) {
      case "Success":
        return "default";
      case "Failed":
        return "destructive";
      case "Pending":
        return "secondary";
      case "In Progress":
        return "outline";
      default:
        return "outline";
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-md font-semibold">
            {executionData?.workflowName}
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={getStatusVariant(executionData?.executionStatus)}>
            {executionData?.executionStatus}
          </Badge>
          <Badge variant="outline">{executionData?.actionType}</Badge>
        </div>
      </div>
      <Badge variant="secondary">{executionData?.audienceType}</Badge>

      <div className="mt-4">
        <div className="border-b-2 border-gray-200"></div>
      </div>

      <div className="mt-4">
        <h3 className="text-sm font-semibold text-foreground">
          Execution Details
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4 mt-3">
        {executionDetails?.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
    </div>
  );
};

export default ExecutionDetails;
